<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1551vwp/tc-custom/9781643361161.jpg?1720280501576" alt="This image is the cover for the book Colonial Plantation Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colonial Plantation Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <b>“A charming compilation of eighteenth-century recipes . . . a well-researched account of Mrs. Horry’s fascinating life-style.” —<i>The North Carolina Historical Review</i></b><br/><br/>Harriott Pinckney Horry began her receipt book more than two hundred years ago. It is being published now for the first time.<br/><br/>You will get a lively sense of what colonial plantation life was like from reading Harriott’s receipt book. She began it in 1770, shortly after she was married, writing recipes and household information in a notebook. Her recipes reflect both English and French culinary traditions. You will recognize in the recipes the origins of some of your contemporary favorites.<br/><br/>Harriott writes also about keeping the dairy and smokehouse, how to dye clothes, what to do about insects, how to care for trees and crops, and how to make soap, all skills she learned in the course of managing the plantation after her husband’s early death.<br/><br/>From Harriott’s writing and Hooker’s knowledgeable introduction and editorial notes, you will learn what it was like to be well-to-do and a member of Southern aristocracy, living in a world of rice and indigo planters, merchants, lawyers, and politicians—the colonial elite. Because knowing about food preferences and eating habits of any people expands our understanding of their nature and times, the receipt book of Harriott Pinckney Horry opens another window on the history of colonial plantations.<br/><br/>“Gives us a very good idea of the household’s prize dishes.” —<i>The Washington Post</i><br/><br/>“Cookbook collectors will love it and even readers who don’t enter the kitchen will find it entertaining.” —<i>The Charleston Evening Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard J. Hooker
      </h2>
      
      <p class="authorDescription body article"><P>Richard J. Hooker received a Ph.D. in history from the University of Chicago. He was one of the founding faculty of Roosevelt University where he taught until 1968 and was for fourteen years chairman of the Department of History. His earlier publications are: The Carolina Backcountry on the Eve of the Revolution: The Journal and Other Writings of Charles Woodmason, Anglican Itinerant; The American Revolution: the Search for Meaning; The Book of Chowder; and Food and Drink in America: A History. He lifes in Beaufort, South Carolina and Lyndonville, Vermont.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70c19872